import React from 'react';
import { SwiperComponent } from 'vitl-component-library';
// component
import Image from '@components/image/image';
// styles
import styles from './personalised-vitamins.module.scss';

interface IProps {
  title: string;
  description: string;
  items: any;
}

const PersonalisedVitamins: React.FC<IProps> = ({ title, description, items }) => {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2>{title}</h2>
        <hr />
        <p className={styles.description}>{description}</p>
        <SwiperComponent
          paginationType="bullets"
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            1280: {
              slidesPerView: 3,
            },
          }}
        >
          {items.map((item: any) => (
            <Image key={item.filename_disk} filename={item.filename_disk} width={500} />
          ))}
        </SwiperComponent>
      </div>
    </section>
  );
};
export default PersonalisedVitamins;
